import { memo } from "react";

import type { ITableHeadProps } from "@components/organisms/pageTable";
import { TableHeading } from "@components/organisms/pageTable/components/tableHeading";
import { TableFilterSearch } from "@components/organisms/pageTable/components/tableFilterSearch";

export const TableHead = memo(function TableHead({
  headingProps,
  tableFilterSearchProps,
}: ITableHeadProps) {
  return (
    <div>
      <TableHeading
        title={headingProps.title}
        icon={headingProps.icon}
        tabProps={headingProps.tabProps}
        onPrint={headingProps.onPrint}
        onDownload={headingProps.onDownload}
      />
      <TableFilterSearch
        filterProps={tableFilterSearchProps?.filterProps}
        searchProps={tableFilterSearchProps?.searchProps}
        actions={tableFilterSearchProps?.actions}
        placeholder={tableFilterSearchProps?.placeholder}
      />
    </div>
  );
});
